'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdVpnKey = function MdVpnKey(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.6 23.4c1.8 0 3.4-1.6 3.4-3.4s-1.6-3.4-3.4-3.4-3.2 1.6-3.2 3.4 1.4 3.4 3.2 3.4z m9.5-6.8h17.3v6.8h-3.4v6.6h-6.6v-6.6h-7.3c-1.3 3.9-5.1 6.6-9.5 6.6-5.5 0-10-4.5-10-10s4.5-10 10-10c4.4 0 8.2 2.7 9.5 6.6z' })
        )
    );
};

exports.default = MdVpnKey;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/vpn-key.js
// module id = 1836
// module chunks = 1